import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';
import { ANALYTICS_ACTION_TOGGLED, ANALYTICS_SUBJECT_RADIO, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import React, { useState } from 'react';
import { MANAGE_PARTNER_APPS_VIEW, TOGGLE_LOYALTY_DISCOUNT } from "../../../../analytics/Events";

const LoyaltyDiscountToggle = ({
  defaultState,
  appKey
}) => {
  const [loyaltyDiscountOpted, toggleLoyaltyDiscount] = useState(defaultState);
  const fireAnalyticsEvent = useAnalyticsEvents();

  const setLoyaltyDiscount = loyaltyDiscountOptIn => {
    const body = {
      state: loyaltyDiscountOptIn
    };
    fetchOk("/rest/1.0/plugins/".concat(appKey, "/loyaltyDiscountOptIn"), {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json'
      }
    });
  };

  const handleAnalyticsEvent = () => fireAnalyticsEvent({
    eventContainer: MANAGE_PARTNER_APPS_VIEW,
    actionSubject: ANALYTICS_SUBJECT_RADIO,
    action: ANALYTICS_ACTION_TOGGLED,
    actionSubjectId: TOGGLE_LOYALTY_DISCOUNT,
    attributes: {
      appKey,
      loyaltyDiscountOpted
    }
  });

  const onChangeLoyaltyDiscount = () => {
    setLoyaltyDiscount(!loyaltyDiscountOpted);
    toggleLoyaltyDiscount(currentState => !currentState);
    handleAnalyticsEvent();
  };

  return /*#__PURE__*/React.createElement(Tooltip, {
    content: loyaltyDiscountOpted ? 'Disable loyalty discount' : 'Enable loyalty discount'
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "toggle-default",
    onChange: onChangeLoyaltyDiscount,
    defaultChecked: loyaltyDiscountOpted,
    isChecked: loyaltyDiscountOpted
  }));
};

export default LoyaltyDiscountToggle;